import { render, staticRenderFns } from "./upload-data.vue?vue&type=template&id=3f07c7ea"
import script from "./upload-data.vue?vue&type=script&lang=js"
export * from "./upload-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports